import { render, staticRenderFns } from "./SubcontractorPreselectionChat.vue?vue&type=template&id=66d4d0b4&scoped=true&"
import script from "./SubcontractorPreselectionChat.vue?vue&type=script&lang=js&"
export * from "./SubcontractorPreselectionChat.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractorPreselectionChat.vue?vue&type=style&index=0&id=66d4d0b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4d0b4",
  null
  
)

export default component.exports